import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BasketballIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8.75 7.25037H11.0391C11.2274 5.46122 12.0793 3.98248 13.2253 3.34196C12.0996 2.08028 10.5238 1.22889 8.75 1.04004V7.25037Z"
		></path>
		<path
			fill="currentColor"
			d="M8.75 8.75037H11.0392C11.2276 10.5394 12.0796 12.018 13.2257 12.6583C12.1 13.9202 10.524 14.7718 8.75 14.9607V8.75037Z"
		></path>
		<path
			fill="currentColor"
			d="M13.254 10.6753C13.5424 11.0874 13.8411 11.3137 14.1093 11.4207C14.561 10.6155 14.8582 9.71205 14.9606 8.75037H12.5497C12.6552 9.534 12.9197 10.1979 13.254 10.6753Z"
		></path>
		<path
			fill="currentColor"
			d="M14.9606 7.25037C14.8582 6.28844 14.5609 5.38474 14.1089 4.57948C13.8409 4.68648 13.5423 4.91276 13.254 5.32466C12.9196 5.80229 12.6551 6.46641 12.5496 7.25037H14.9606Z"
		></path>
		<path
			fill="currentColor"
			d="M7.25 7.25037V1.04011C5.47637 1.22912 3.90069 2.08054 2.77515 3.34221C3.92095 3.98286 4.77266 5.46145 4.96093 7.25037H7.25Z"
		></path>
		<path
			fill="currentColor"
			d="M3.45043 7.25037C3.34495 6.46641 3.08037 5.80229 2.74603 5.32466C2.45789 4.91304 2.15951 4.68678 1.89161 4.5797C1.43975 5.3849 1.14249 6.28853 1.04004 7.25037H3.45043Z"
		></path>
		<path
			fill="currentColor"
			d="M1.89127 11.4204C1.43961 10.6154 1.14247 9.71197 1.04004 8.75037H3.45033C3.34478 9.534 3.08026 10.1979 2.74603 10.6753C2.45777 11.0871 2.15926 11.3134 1.89127 11.4204Z"
		></path>
		<path
			fill="currentColor"
			d="M2.77471 12.658C3.92058 12.0176 4.7724 10.5392 4.96085 8.75037H7.25V14.9606C5.47614 14.7716 3.90028 13.92 2.77471 12.658Z"
		></path>
	</svg>
))
